export default __webpack_public_path__ + "static/media/board.3c83f099.svg";